'use strict';
const MMSVG = require('@mindmup/mapsvg'),
	ThemeProcessor = require('@mindmup/mapjs-core/src/theme/theme-processor'),
	TSpanStickersEngine = require('@mindmup/mapsvg/src/tspan-stickers-engine'),
	TextWidthCache = require('../models/text-width-cache'),
	CanvasTextSizer = require('./canvas-text-sizer'),
	themeProcessor = new ThemeProcessor(),
	canvasTextSizer = new CanvasTextSizer(themeProcessor),
	textWidthCache = new TextWidthCache(canvasTextSizer.textWidth);

module.exports = function buildSvg(content, themeProvider, options) {
	const textEngine = new MMSVG.TSpanTextEngine(textWidthCache.textWidth, MMSVG.NaiveLineBreak, {dontSpecifyLength: true});
	return '<?xml version="1.0" encoding="UTF-8"?>\n' +
		MMSVG.generateSvg (
			content,
			textEngine,
			new TSpanStickersEngine(textEngine),
			options
		);
};
